module.exports = __webpack_public_path__ + "img/cantonera-foam-reciclada.b21ffd73.jpg";